module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-04-a60d06f9b8cf2966af4db4a0ab926abc.png";